export const IconVacancyMakeHot: {
  name: 'icon_vacancy_make_hot-97254d49acbb'
} = {
  name: 'icon_vacancy_make_hot-97254d49acbb'
}
